import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueRouter from 'vue-router';
import VideoPE from './components/videope/video.vue'
import Login from './components/login/login.vue'
import Expird from './components/expired/expired.vue';
import HelloWorld from './components/HelloWorld.vue';
import VueSweetalert2 from 'vue-sweetalert2';
import VueCookies from "vue-cookies-ts"
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
import GAuth from 'vue-google-oauth2'
import Vuex from "vuex";
import Loginwithtelegram from './components/login/loginwithtelegram.vue';

Vue.config.productionTip = false
Vue.use(VueRouter);
Vue.use(VueSweetalert2);
Vue.use(VueCookies);
Vue.use(Toast);
Vue.use(Vuex);
const gauthOption = {
  clientId: '26648605715-0t7vkhio49rct6mje791q577ncadljub.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account',
  fetch_basic_profile: true,
  plugin_name: 'Cam-Login'
}
Vue.use(GAuth, gauthOption)
const store = new Vuex.Store({
  state: {
    authenticated: localStorage.getItem('hasLogin')
  },
  mutations: {
    setAuthentication(state, status) {
      state.authenticated = status;
    }
  }
});
const router = new VueRouter({
  routes: [{
      path: '/login',
      name: 'login',
      component: Loginwithtelegram
    },
    {
      path: '',
      name: 'login',
      component: Loginwithtelegram
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: HelloWorld,
      beforeEnter: (to, from, next) => {
        console.log(store.state.authenticated)
        if (store.state.authenticated == false || store.state.authenticated == null) {


          next({
            name: 'login'
          })

        } else {



          next()



        }

      }
    },
    {
      path: '/fb-videope',
      name: 'fb-videope',
      component: VideoPE,
      beforeEnter: (to, from, next) => {
       
        if (store.state.authenticated == false || store.state.authenticated == null) {


          next({
            name: 'login'
          })

        } else {



          next()



        }

      }

    },
    {
      path: '/expired',
      name: 'expired',
      component: Expird,
      beforeEnter: (to, from, next) => {
       
        if (store.state.authenticated == false || store.state.authenticated == null) {


          next({
            name: 'login'
          })

        } else {



          next()



        }

      }

    },
    {
      path: '/logintelegram',
      name: 'logintelegram',
      component: Loginwithtelegram,
    },
   
   
    // {
    //   path: '*',

    //   component: Pagenotfound
    // }
  ]

})

new Vue({
  render: h => h(App),
  vuetify,
  router: router,
  store: store,

}).$mount('#app')